import { h } from "../core/dom.js";
import { navigate } from "../core/router.js";

export function planTabs(active) {
  return h(
    "div",
    { class: "tabs", "aria-label": "Plan sections" },
    h("button", { class: active === "workouts" && "active", onClick: () => navigate("/workouts") }, "Workouts"),
    h("button", { class: active === "programs" && "active", onClick: () => navigate("/programs") }, "Programs")
  );
}
